export const numberToReadableString = (num: number): string => {
  if (num >= 100000) {
    return `${Math.round(num / 1000)}K`;
  }

  if (num >= 1000) {
    return `${Math.round(num / 100) / 10}K`;
  }
  return num.toString();
};
